import cx from "classnames"
import { LargeCardProps } from "./LargeCard.types"
import "./LargeCard.css"
import Icon from "src/shared/icons"
import { useEffect, useState } from "react"
import { InputText } from "../../forms"
import coinMoney from "src/shared/icons/coin-money"
import {
    ModalDeleteCat,
} from "src/pages/gastos/components/DeletCategoriaModal/DeletCategoriaModal"
import AddSubCat from "src/pages/gastos/components/AddModal/AddSubCat/AddSubCat"
import EditCategoriaGastos from "src/pages/gastos/components/AddModal/EditCategoriaGastos/EditCategoriaGastos"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"

const NOT_EDITABLE_SUBCATEGORY = "Pago de propinas"

function LargeCard({
    className = "",
    containerClassName = "",
    title = "",
    subtitle = "",
    gastos,
    limiteMensual = "",
    presupuesto = 0,
    onConfirmEdit,
    subCategorias,
    id,
    startOpened = false,
}: LargeCardProps): JSX.Element {
    const [isEditMode, setIsEditMode] = useState<boolean>(false)
    const [newLimite, setNewLimite] = useState<string>(limiteMensual)
    const [deletedSubcategoryList, setDeletedSubcategoryList] = useState<string[]>([])
    const [isCardOpen, setIsCardOpen] = useState(startOpened)
    const [deleteModal, setDeleteModal] = useState(false)
    const [isAddSubcategoryOpen, setIsAddSubcategoryOpen] = useState(false)
    const [addSubcategoryList, setaddSubcategoryList] = useState<string[]>([])
    const [addEdith, setAddEdit] = useState(false)
    const [newData, setNewData] = useState<{
        limite: string | undefined
        gasto: string | undefined
    }>({
        limite: "",
        gasto: "",
    })
    const dataAnterior = {
        gasto: title,
        limiteA: limiteMensual,
    }
    const [array, setArray] = useState<Array<string>>([])

    useEffect(() => {
        setNewLimite(limiteMensual)
    }, [limiteMensual])
    

    const toggleSelected = (subcategoria: string) => {
        let newArray = array
        if (array.length > 0 && array.includes(subcategoria)) {
            newArray = array.filter((item) => item !== subcategoria)
        } else {
            newArray.push(subcategoria)
        }
        setArray(newArray)
    }
    const onEdit = () => {
        
        const limite = limiteMensual !== newLimite ? newLimite : undefined

        if (limite || array.length > 0) {
            setNewData({
                gasto: "",
                limite: limite,
            })
            setDeletedSubcategoryList(array)
            setAddEdit(true)
        } else {
            if(addSubcategoryList.length) {
                setAddEdit(true)
                return
            }
            setIsEditMode(false)
        }
    }

    const reload = () => {
        setAddEdit(false)
        setIsEditMode(false)
        setArray([])
        setUpdateArray(updateSubArray())
    }

    const setEndUpdate = () => {
        setIsCardOpen(false)
        setAddEdit(false)
        setIsEditMode(false)
        setArray([])
        setUpdateArray(updateSubArray())
        setNewData({
            limite: "",
            gasto: "",
        })
        setNewLimite(limiteMensual)
    }

    const timeEnd = (error: boolean) => {
        !error ? reload() : setEndUpdate()
        onConfirmEdit(!error)
    }

    const subFiltered = subCategorias.filter((sub) => sub.eliminado === false)

    const SendDataEdith = () => {
        return (
            <>
                <EditCategoriaGastos
                    newSubcategoryList={addSubcategoryList}
                    title={title}
                    subCategorias={subFiltered}
                    onConfirm={(error) => {
                        setaddSubcategoryList([])
                        timeEnd(error)
                    }}
                    onClose={() => setEndUpdate()}
                    id={id}
                    dataAnterior={dataAnterior}
                    resEdit={newData}
                    deletedArray={deletedSubcategoryList}
                />
            </>
        )
    }

    const updateSubArray = (num?: number) => {
        const updArray: boolean[] = []
        if (!num) {
            subCategorias.map(() => {
                updArray.push(false)
            })
        } else {
            updateArray.map((x) => {
                updArray.push(x)
            })
            updArray[num] = !updArray[num]
        }
        return updArray
    }

    const [updateArray, setUpdateArray] = useState(updateSubArray())

    return (
        <div className={cx("largecard__container", containerClassName)}>
            <div className={cx("card", className)}>
                {isEditMode ? (
                    <div className="largecard-left-added">
                        <div className="card-content-line-added-edit">
                            <div>
                                <p className="card-header-title" style={{ marginBottom: 20 }}>
                                    {title}
                                </p>
                                <p className="card-content-line-title-edit">Límite mensual de gasto:</p>
                                <InputText
                                    type="text"
                                    icon={coinMoney}
                                    className="card-content-line-input"
                                    style={{ border: "1px solid #959595" }}
                                    placeholder="Agrega un monto"
                                    value={newLimite}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        setNewLimite(value.replace(/[^\d.]/g, ""))
                                    }}
                                />
                            </div>
                            <p className="card-content-line-title" style={{ marginTop: 66 }}>
                                Presupuesto disponible:
                            </p>
                            <p className="card-content-line-subtitle" style={{ marginTop: 66 }}>
                                {formatCurrencyToFixed(presupuesto)}
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="largecard-left">
                        <div className="largecard-left-top">
                            <p className="card-header-title">{title}</p>
                            <p className="card-header-subtitle">{subtitle}</p>

                            <div className="card-content-line">
                                <p className="card-content-line-title">Límite mensual de gasto:</p>
                                <p className="card-content-line-subtitle">
                                    {limiteMensual !== "0" ? formatCurrencyToFixed(Number(limiteMensual)) : "Sin asignar"}
                                </p>
                                <p className="card-content-line-title">Presupuesto disponible:</p>
                                <p className="card-content-line-subtitle">
                                    {formatCurrencyToFixed(presupuesto)}
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="largecard-right">
                    {!isEditMode && (
                        <div
                            style={{ display: "flex" }}
                            className="largecard-button"
                            onClick={() => {
                                setIsEditMode(true)
                                setIsCardOpen(true)
                            }}
                        >
                            <Icon name="pencil" className="largecard-button-icon" />
                        </div>
                    )}
                    {!!isEditMode && (
                        <div
                            style={{ display: "flex" }}
                            className="largecard-button"
                            onClick={() => {
                                onEdit()
                            }}
                        >
                            <Icon name="save3Fill" className="largecard-button-icon" />
                        </div>
                    )}
                    {/* <div
                        style={{ display: title === "Propinas" ? "none" : "flex" }}
                        className="largecard-button"
                        onClick={() => {
                            setDeleteModal(true)
                        }}
                    >
                        <Icon
                            name="trashFilled"
                            className="largecard-button-icon"
                            onClick={() => setDeleteModal(true)}
                        />
                    </div> */}
                    {subFiltered && subFiltered?.length > 0 && (
                        <div className="chevroUp-button" onClick={() => {
                            setIsCardOpen(v => !v)
                            setIsEditMode(false)
                        }}>
                            <Icon
                                width={"35px"}
                                height={"35px"}
                                name="chevronUp"
                                className={"drop"}
                                style={{
                                    transform: ` ${isCardOpen ? "translateX(-40%)" : ""} rotate(${
                                        isCardOpen ? "-180deg" : "0deg"
                                    })`,
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isCardOpen && (
                <div>
                    <div className="card-content__containerSubGrup">
                        {subCategorias.map((subcategoria, index) => (
                            <div
                                style={{ display: subcategoria.eliminado ? "none" : "flex" }}
                                key={index}
                                className={`${
                                    array.includes(subcategoria.subcategoria_gasto_id) && !!isEditMode
                                        ? "subCatgoria-pil-selected"
                                        : "subCatgoria-pil"
                                }`}
                            >
                                <p className="card-content_subcategory__text">{subcategoria.subcategoria}</p>
                                {!!isEditMode && subcategoria.subcategoria !== NOT_EDITABLE_SUBCATEGORY && (
                                    <Icon
                                        name="xclose"
                                        color={`${
                                            array.includes(subcategoria.subcategoria_gasto_id) ? "#fff" : "#fff"
                                        }`}
                                        className={`subCatgoria-pil__icon`}
                                        onClick={() => {
                                            toggleSelected(subcategoria.subcategoria_gasto_id)
                                            setUpdateArray(updateSubArray(index))
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                        {addSubcategoryList.map((subcategoria, index) => (
                            <div
                                style={{ display: "flex" }}
                                key={index}
                                className={`subCatgoria-pil`}
                            >
                                <p className="card-content_subcategory__text">{subcategoria}</p>
                                <Icon
                                    name="xclose"
                                    color={`#fff`}
                                    className={`subCatgoria-pil__icon`}
                                    onClick={() => {
                                        setaddSubcategoryList(v => v.filter(sub => sub !== subcategoria))
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                    {
                        isEditMode &&
                        <div className="largecard-left-bottom">
                            <div
                                onClick={() => setIsAddSubcategoryOpen(true)}
                                style={{ marginTop: 30 }}
                                className="card-content-line-edit-subcategoria"
                            >
                                <Icon color="var(--primary)" name={"plusCircle"} />
                                <p>Agregar subcategoría</p>
                            </div>
                        </div>
                    }
                </div>
            )}
            {addEdith && <SendDataEdith />}
            {/* <DeletCategoriaModal
                id={id}
                title={title}
                presupuesto={presupuesto}
                open={deleteMod}
                onClose={() => setDeleteMode(false)}
                onSub={(value) => onSubDelete(value)}
            /> */}
            <ModalDeleteCat
                open={deleteModal}
                id={id}
                onClose={() => setDeleteModal(false)}
                title={title}
                presupuesto={presupuesto}
            />
            {!!isAddSubcategoryOpen && <AddSubCat newSubcategoryList={addSubcategoryList} subCategorias={subCategorias} id={id} onClose={() => setIsAddSubcategoryOpen(false)} onSub={(value) => setaddSubcategoryList(v => [...v, value])} />}
        </div>
    )
}

export default LargeCard
